import React, { useState, useEffect } from "react";
import SectionCard from "./SectionCard";
import AssignedDriver from "./AssignedDriver";
import UnassignedDriver from "./UnassignedDriver";
import { Button, Popover } from "antd";
import { PlusIconForAttempts } from "../../common/CustomIcon";
import "./PickupDriverView.scss";
import DriverAttemptedDetails from "../../components/orders/DriverAttemptedDetails";
import I18n from "../../common/I18n";
import DisableWrapper from "./DisableWrapper";





const AssignedDriverView = ({ loc, drivers, warehouse_id, currentOrder, currentOrg, refreshDetails, maximumHeight = "auto", isShipper = false, showActions = true, isCreditLimitExceed = false ,isTender, isTenderAgentSide = false, isAssignable = true,isLinehaulOrder = false, organizationSettings = {}}) => {
    const [isDriverAssigned, setIsDriverAssigned] = useState(loc?.driver_details?.id)
    useEffect(() => {
        setIsDriverAssigned(loc?.driver_details?.id || false)
    }, [loc?.driver_details])

    const attempts = loc?.driver_attempts || [];
    // A linehaul leg (origin/destination warehouse) can't take a driver, but it
    // can still be tendered — so disable only the Assign action, not the whole
    // card (which would also kill the Tender Order button).
    const isLinehaulLeg = isLinehaulOrder && (loc?.label_code === 'ORN' || loc?.label_code === 'DST');
    const isDisabled = isLinehaulLeg || !isAssignable;
    // Blanket-disable the card body only for non-linehaul "can't assign" reasons;
    // a linehaul leg keeps its body live so Tender Order stays clickable.
    const bodyDisabled = !isLinehaulLeg && isDisabled;
    const renderAttempts = (attempts) => (
      <Popover
      title={`${I18n.t("invoice_lines.attempts")} to the order #${currentOrder.order_number}`}
        content={
          <DriverAttemptedDetails
            record={loc} // Pass the `loc` as the record prop to DriverAttemptedDetails
            isMilitaryTime={true} // Update as per your requirement
            timeZone="GMT" // Update as per your requirement
            timeZoneName="GMT" // Update as per your requirement
          />
        }
        trigger="click" // Only show popover on click
        overlayStyle={{
          maxWidth: 500,
        }}
        placement="topLeft"
        destroyTooltipOnHide={true} // Ensures that the popover gets removed from the DOM when hidden
      >
        <Button className="attempt-button" disabled={isDisabled}>
          <PlusIconForAttempts style={{ paddingRight: "8px" }} />
          <span className="button-2-large" style={{ paddingLeft: "8px" }}>
            {attempts.length}
          </span>
          <span className="button-2-large" style={{ paddingLeft: "4px" }}>
            {attempts.length > 1 ? " Attempts" : " Attempt"}
          </span>
        </Button>
      </Popover>
    );

    return (
      <SectionCard
        title={currentOrder?.type_of_order !== "MS" ? `${loc?.label_name || ""} Driver` : 'Driver'}
        extraActionNode={attempts.length > 0 ? (<div className="assigned-driver-view">{renderAttempts(attempts)}</div>) : null}
        maximumHeight={maximumHeight}
      >
        <div className={`driver-section ${!isDriverAssigned && bodyDisabled ? "disabled" : ""}`}>
          <DisableWrapper isDisabled={isDisabled}>
          {isDriverAssigned ? (
            <AssignedDriver
              driverDetails={loc?.driver_details}
              drivers={drivers}
              location={loc}
              currentOrg={currentOrg}
              currentOrder={currentOrder}
              refreshDetails={refreshDetails}
              isCreditLimitExceed={isCreditLimitExceed}
              showActions={showActions}
              isTenderAgentSide={isTenderAgentSide}
              orgSettings={organizationSettings}
            />
          ) : (
            showActions && (
              <UnassignedDriver
                loc={loc}
                isTender={isTender}
                drivers={drivers}
                warehouse_id={warehouse_id}
                currentOrder={currentOrder}
                driverDetails={loc?.driver_details}
                refreshDetails={refreshDetails}
                currentOrg={currentOrg}
                isCreditLimitExceed={isCreditLimitExceed}
                organizationSettings={organizationSettings}
                disableAssign={isDisabled}
            />
            )
          )}
          </DisableWrapper>
        </div>
      </SectionCard>
    );
}

export default AssignedDriverView;